var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { filter } from 'rxjs/operators';
var DynamicDatePicker = /** @class */ (function (_super) {
    __extends(DynamicDatePicker, _super);
    function DynamicDatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null,
            invalid: false,
            help: null
        };
        return _this;
    }
    DynamicDatePicker.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            invalid: null,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            invalid: true,
            help: JSON.stringify(error.constraints)
        }); });
    };
    DynamicDatePicker.prototype.setValue = function (value) {
        this.setState({
            value: value
        });
        this.props.dataState.set(this.props.control.path, value, {
            sender: this
        });
    };
    DynamicDatePicker.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicDatePicker.prototype.render = function () {
        var _this = this;
        return React.createElement(KeyboardDatePicker, __assign({}, this.props.options, { label: this.props.control.label, error: this.state.invalid, helperText: this.state.help, value: this.state.value, onChange: function (value) { return _this.setValue(value); } }));
    };
    return DynamicDatePicker;
}(React.Component));
export default DynamicDatePicker;
//# sourceMappingURL=DateTime.js.map